import { render, staticRenderFns } from "./budget-gkkp-sum-calc-main.vue?vue&type=template&id=295f495a&"
import script from "./budget-gkkp-sum-calc-main.vue?vue&type=script&lang=ts&"
export * from "./budget-gkkp-sum-calc-main.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports